import React, { useEffect, useState } from "react";
import { APP_VERSION, shouldOfferRefresh, fetchDeployedVersion } from "../Common/appVersion";

// "A new version is available — Refresh" (4.11.55). Web users keep a tab open for days; after a deploy the tab
// still runs the old app. Checked when the tab comes back into view and every 30 minutes, against the
// version.json written by the build (scripts/app-version.js). Dismissed until the next new version.
const EVERY_MS = 30 * 60 * 1000;

const NewVersionBanner = () => {
  const [deployed, setDeployed] = useState(null);
  const [dismissed, setDismissed] = useState(null);

  useEffect(() => {
    let alive = true;
    const check = async () => {
      if (document.visibilityState === "hidden") return;
      const v = await fetchDeployedVersion();
      if (alive && v) setDeployed(v);
    };
    const onVisible = () => document.visibilityState === "visible" && check();
    document.addEventListener("visibilitychange", onVisible);
    const timer = setInterval(check, EVERY_MS);
    return () => {
      alive = false;
      document.removeEventListener("visibilitychange", onVisible);
      clearInterval(timer);
    };
  }, []);

  if (!shouldOfferRefresh(APP_VERSION, deployed) || dismissed === deployed) return null;
  return (
    <div role="status" data-testid="new-version-banner" style={{ position: "fixed", left: 12, right: 12, bottom: 84, zIndex: 3000, maxWidth: 520, margin: "0 auto", display: "flex", alignItems: "center", gap: 10, padding: "10px 12px", borderRadius: 12, background: "#17212B", color: "#FFFFFF", boxShadow: "0 6px 20px rgba(0,0,0,0.25)", fontSize: 14 }}>
      <span style={{ flex: 1 }}>A new version of Andiamo is available.</span>
      <button type="button" onClick={() => window.location.reload()} style={{ border: 0, borderRadius: 8, padding: "8px 14px", background: "#E2702B", color: "#17212B", fontWeight: 700, cursor: "pointer" }}>
        Refresh
      </button>
      <button type="button" aria-label="Not now" onClick={() => setDismissed(deployed)} style={{ border: 0, background: "transparent", color: "#FFFFFF", fontSize: 18, lineHeight: 1, padding: "6px 8px", cursor: "pointer" }}>
        ×
      </button>
    </div>
  );
};

export default NewVersionBanner;
